import React from 'react';

import { Builds } from '../../types/VersionDependent';

export type Props = {
  CB?: JSX.Element | null;
  CBAT?: JSX.Element | null;
  CBBE?: JSX.Element | null;
  CBDE?: JSX.Element | null;
  CBDK?: JSX.Element | null;
  CBES?: JSX.Element | null;
  CBFR?: JSX.Element | null;
  CBIE?: JSX.Element | null;
  CBIT?: JSX.Element | null;
  CBMX?: JSX.Element | null;
  CBNO?: JSX.Element | null;
  CBPL?: JSX.Element | null;
  CBSE?: JSX.Element | null;
  CK?: JSX.Element | null;
  CKFR?: JSX.Element | null;
  CKUK?: JSX.Element | null;
  GCSAT?: JSX.Element | null;
  GCSBE?: JSX.Element | null;
  GCSDE?: JSX.Element | null;
  GCSFR?: JSX.Element | null;
  GCSIE?: JSX.Element | null;
  GCSIT?: JSX.Element | null;
  GCSNL?: JSX.Element | null;
  GCSUK?: JSX.Element | null;
  GCUK?: JSX.Element | null;
  defaultValue?: JSX.Element | null;
  values?: { keys: Builds[]; value: JSX.Element | null }[];
};

export const ApplicationBuildContainer = (props: Props) => {
  const {
    values,
    defaultValue = null,
    CB = defaultValue,
    CBES = defaultValue,
    CBPL = defaultValue,
    CBBE = defaultValue,
    CBDE = defaultValue,
    CBIT = defaultValue,
    CBIE = defaultValue,
    CBFR = defaultValue,
    CBAT = defaultValue,
    CBSE = defaultValue,
    CBMX = defaultValue,
    CBNO = defaultValue,
    CBDK = defaultValue,

    CK = defaultValue,
    CKFR = defaultValue,
    CKUK = defaultValue,

    GCUK = defaultValue,
    GCSUK = defaultValue,
    GCSDE = defaultValue,
    GCSFR = defaultValue,
    GCSNL = defaultValue,
    GCSIT = defaultValue,
    GCSIE = defaultValue,
    GCSAT = defaultValue,
    GCSBE = defaultValue,
  } = props;

  if (values && values.length > 0) {
    const matched = values.find(({ keys }) =>
      keys.includes(CONFIG.applicationBuild as Builds));
    if (matched?.value) {
      return <>{matched.value}</>;
    }
  }

  return (
    <> {
      (() => {
        switch (CONFIG.applicationBuild) {
          case 'CB':
            return CB;
          case 'CBAT':
            return CBAT;
          case 'CK':
            return CK;
          case 'CBBE':
            return CBBE;
          case 'GCUK':
            return GCUK;
          case 'GCSUK':
            return GCSUK;
          case 'CBDE':
            return CBDE;
          case 'CBIT':
            return CBIT;
          case 'CBIE':
            return CBIE;
          case 'CBES':
            return CBES;
          case 'CBSE':
            return CBSE;
          case 'CBMX':
            return CBMX;
          case 'GCSAT':
            return GCSAT;
          case 'GCSDE':
            return GCSDE;
          case 'GCSBE':
            return GCSBE;
          case 'CBFR':
            return CBFR;
          case 'GCSFR':
            return GCSFR;
          case 'GCSNL':
            return GCSNL;
          case 'GCSIT':
            return GCSIT;
          case 'GCSIE':
            return GCSIE;
          case 'CKFR':
            return CKFR;
          case 'CKUK':
            return CKUK;
          case 'CBPL':
            return CBPL;
          case 'CBNO':
            return CBNO;
          case 'CBDK':
            return CBDK;
          default:
            return defaultValue;
        }
      })()
    } </>
  );
};

ApplicationBuildContainer.displayName = 'ApplicationBuildContainer';
